var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NewsletterService } from '../services/NewsletterService';
import { CloseIcon, NewsletterIcon } from './atoms';
import { Vue, Component } from 'vue-property-decorator';
import linker from '../linker';
var Newsletter = (function (_super) {
    __extends(Newsletter, _super);
    function Newsletter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.newsletter = null;
        _this.show = true;
        return _this;
    }
    Newsletter_1 = Newsletter;
    Newsletter.getStoreValue = function (newsletter) {
        return newsletter.id + "_" + newsletter.majorVersion;
    };
    Newsletter.prototype.mounted = function () {
        this.load();
    };
    Newsletter.prototype.closeClicked = function () {
        var store = window.localStorage;
        if (store && this.newsletter) {
            store.setItem(Newsletter_1.storeKey, Newsletter_1.getStoreValue(this.newsletter));
        }
        this.updateShow();
    };
    Newsletter.prototype.load = function () {
        var _this = this;
        new NewsletterService().load(!window.location.search.match(/(\?|\&)Vorschau($|\=|\&)/)).then(function (item) {
            _this.newsletter = item;
            _this.updateShow();
        });
    };
    Newsletter.prototype.updateShow = function () {
        var store = window.localStorage;
        if (store) {
            var lastNewsletterKey = store.getItem(Newsletter_1.storeKey);
            this.show = this.newsletter && lastNewsletterKey !== Newsletter_1.getStoreValue(this.newsletter);
        }
    };
    var Newsletter_1;
    Newsletter.storeKey = 'lastNewsletterKey';
    Newsletter = Newsletter_1 = __decorate([
        Component({
            components: {
                CloseIcon: CloseIcon,
                NewsletterIcon: NewsletterIcon,
            },
        })
    ], Newsletter);
    return Newsletter;
}(Vue));
export default Newsletter;
linker.register('newsletter', Newsletter);
